export default "__VITE_ASSET__DCclfk8U__"